import * as React from 'react';
import { cn } from '@/lib/cn';

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, rows = 4, ...props }, ref) => (
  <textarea
    ref={ref}
    rows={rows}
    className={cn(
      'block w-full rounded-[var(--radius-input)] border-0 bg-bg px-3 py-2 text-sm text-text outline-1 -outline-offset-1 outline-border placeholder:text-text-subtle',
      'focus:outline-2 focus:-outline-offset-2 focus:outline-accent resize-y',
      'disabled:cursor-not-allowed disabled:opacity-50',
      className
    )}
    {...props}
  />
));
Textarea.displayName = 'Textarea';
